import React, { useState } from "react";
import { Steps } from "antd/lib";
import LifeSep1 from "./Step1";
import LifeSep2 from "./Step2";
import LifeSep3 from "./Step3";
const { Step } = Steps;

const LifeStep = () => {
  const [current, setCurrent] = useState(0);

  const steps = [
    {
      content: (
        <div className="step-container-health">
          <LifeSep1 setCurrent={setCurrent} current={current} />
        </div>
      ),
    },
    {
      content: (
        <div className="step-container-health">
          <LifeSep2 setCurrent={setCurrent} current={current} />
        </div>
      ),
    },
    {
      content: (
        <div className="step-container-health">
          <LifeSep3 setCurrent={setCurrent} current={current} />
        </div>
      ),
    },
  ];
  // console.log(current)
  return (
    <>
      <div className="row justify-content-center life-stepOutr">
        {current === 0 ? (
          <p className="step-ouTr-head">Get an Instant Term Insurance Quote</p>
        ) : current === 1 ? (
          <p className="step-ouTr-head">Help Us With Your Few Details</p>
        ) : current === 2 ? (
          <p className="step-ouTr-head">How can we connect with You?</p>
        ) : null}
        <div className="d-flex align-items-center justify-content-center img-0">
          <Steps className="step-life-prg" current={current} progressDot>
            {steps?.map((item) => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
        </div>
        <div className="text-center">{steps[current].content}</div>
      </div>
    </>
  );
};

export default LifeStep;
